module.exports = require("core-js/modules/esnext.map.some.js");